import { render, staticRenderFns } from "./cardPerfilPaciente.vue?vue&type=template&id=0410b6c6&scoped=true"
import script from "./cardPerfilPaciente.vue?vue&type=script&lang=js"
export * from "./cardPerfilPaciente.vue?vue&type=script&lang=js"
import style0 from "./cardPerfilPaciente.vue?vue&type=style&index=0&id=0410b6c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0410b6c6",
  null
  
)

export default component.exports